import { AuthLayout } from 'layouts/AuthLayout';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useNavigate, useNavigation } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { userSelector } from 'slices/userSlice';
import { setError } from 'slices/userSlice';
import { login } from 'slices/userSlice';


const Footer = memo(() => (
    <div className='center_wrapper'>
        <p className="para3">Don’t have Interpreter Account? <Link to="/register">Let’s Create One!</Link></p>
    </div>
))

// let slice;
function Login() {
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loader } = useSelector(userSelector)

    const [formValues, setFormValues] = useState({
        email: '',
        password: '',
    });

    const handleChange = useCallback((e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    }, [formValues])

    const togglePasswordVisibility = useCallback(() => {
        setShowPassword(!showPassword);
    }, [showPassword])

    const submitCallback = (status, message) => {
        if (status) {
            toast.success("Login Successfully")
            navigate('/', { replace: true });
        }
        else {
            toast.error("Invalid Credentials");
        }
    };
    const resetAllErrors = () => {
        dispatch(setError({}))
    }
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        resetAllErrors()
        dispatch(login(formValues, submitCallback))
    }, [formValues]);

    return (
        <AuthLayout
            heading="Welcome to Global Village"
            title="Log in to your account."
            footer={<Footer />}


        >
            <form className='auth_form' action='' onSubmit={handleSubmit} >
                <div className="form-group">
                    <div className="row-input">
                        <img src="/images/mail.png" alt="" />
                        <input type="email" name="email" id="email" required onChange={handleChange} value={formValues.email} autoComplete="off" placeholder="Enter your email" />
                    </div>
                </div>
                <div className="form-group">
                    <div className="row-input">
                        <img src="/images/lock.png" alt="" />
                        <input type={showPassword ? "text" : "password"} name="password" id="password" required onChange={handleChange} autoComplete="off" placeholder="Enter your password" value={formValues.password} />
                        <img src={showPassword ? "/images/eye-close.png" : "/images/eye.png"} alt="" onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }} />
                    </div>
                </div>
                <div className="para2">
                    <div className="form-row">
                        <input className="form__checkbox" name="rememberme" type="checkbox" id="rememberme" value="forever" />
                        <label className="form__label" for="rememberme">Remember Me</label>
                    </div>
                    <Link to="/forgot-password">
                        Forget Password?
                    </Link>
                </div>
                <button disabled={loader} type="submit" className={`btn_auth ${loader? "disabled-button" : ""} `}>
                    {loader ?
                        <>
                            <Spinner size="sm">
                                Loading...
                            </Spinner>

                            <span>
                                {' '}Loading
                            </span>
                        </>
                        :
                        <span>
                            Log in
                        </span>
                    }
                </button>
            </form>
        </AuthLayout>
    )

}

export default Login;
